import { createHtmlElement } from '../../functions';
import gsap from 'gsap';
import { settingsData } from '../../settings';
import {Slider} from './Slider';
import {getDictionary, getLoaderData} from "../crm/crm-requests";
import {addTilesToScene} from "../threejs/environment";
import {reduceImage} from "../widgets/gallery/galleryDesktop";

export function preloaderSliderInit() {
  document.addEventListener('gesturestart', function (e) {
    e.preventDefault();
  });

  const tl = gsap.timeline({repeat: -1, repeatDelay: 0.4});

  const {cdnRepository,projectFolder, features} = config;
  const url = `${cdnRepository}/${projectFolder}/resources/img/logo.png`;
  const mainContainer = createHtmlElement(document.body,'','div',['preloader__main__container']);
  const topSide = createHtmlElement(mainContainer,'','div',['preloader__top__container']);
  const bottomSide = createHtmlElement(mainContainer,'','div',['preloader__bottom__container']);
  const centerContainer = createHtmlElement(mainContainer,'','div',['preloader__info__container']);
  const logo = createHtmlElement(centerContainer,'','div',['preloader__logo']);
  logo.style.backgroundImage = `url(${url})`;
  const progressBar = createHtmlElement(centerContainer,'','div',['preloader__progressbar']);

  loaderLineProgress();
  launchPreloaderSlider()
}

export function removePreloader () {
  const preloader = document.querySelector('.preloader__main__container');
  if (!preloader)
    return;
  const preloaderCenterBlock = preloader.querySelector('.preloader__info__container');
  const topBox = preloader.querySelector('.preloader__top__container');
  const bottomBox = preloader.querySelector('.preloader__bottom__container');

  preloader.classList.add('isFinish');

  const tl = gsap.timeline();

  tl.to(preloaderCenterBlock,{ duration: 0.8, delay: 1, opacity:0}).addLabel('removeCenterBlockAnimation');
  tl.to(topBox,{duration: 1, ease: 'power3.inOut', height:0}, 'removeCenterBlockAnimation-=0.4');
  tl.to(bottomBox,{duration: 1, ease: 'power3.inOut', height:0},'removeCenterBlockAnimation-=0.4').then(()=>{
    preloader.remove();
  })
}

export function loaderLineProgress() {
  if (settingsData.totalPercent === 100) {
    return true;
  }

  let actualPercent = Math.floor(settingsData.totalPercent);

  for (let percent = 0; percent <= actualPercent; percent++) {
    // const text = document.querySelector('.custom-tooltip>.text');
    const progressBar = document.querySelector('.preloader__progressbar');
    // text.innerHTML = `${percent}%`;
    if (progressBar){
      progressBar.style.width = `${percent}%`;
    }
  }
  // requestAnimationFrame(loaderLineProgress);
  return false;
}

export function addCustomPreloader (parent,name) {
  const mainContainer = createHtmlElement(parent,'','div',['tumbs__preloader']);
  if (name){
   mainContainer.dataset.name = name;
   mainContainer.classList.add('custom-preloader');
  }
  const preloader = createHtmlElement(mainContainer,'','div',['lds-ring']);
}

export function removeCustomPreloader (name) {
  let preloader;

  if (name){
    preloader = document.querySelector('.tumbs__preloader[data-name="'+name+'"]');
  } else {
    preloader = document.querySelector('.tumbs__preloader');
  }

  preloader && preloader.remove();
}

async function launchPreloaderSlider() {
  const permittedExtensions = ['mp4'];
  const dictionaryResponse = await getDictionary();
  config['dictionary'] = dictionaryResponse.data;
  const loaderResponse = await getLoaderData();
  const loaderData = await loaderResponse.data;
  const musicParams = getMusicParams();

  /** DEBUG SECTION */
  /** Should be always commented before push */

  // no music
  // musicParams.url = null;
  // musicParams.extension = null;

  // loaderData.length = 2;

  // video 0 element - a video at the beginning, >= 1 element - video at the end
  // loaderData[1].imageUrl = 'https://dreamsimages.bmby.com/Ibiza/projectassets/gallery/videos/P1100289_15.mp4';

  /** END DEBUG SECTION */

  if (!Array.isArray(loaderData)) {
    skipSlider();
    return;
  }
  const videoParams = getVideoParams(loaderData, permittedExtensions);
  const checkedSlides = [];

  const checkImageContainer = document.createElement('div');
  checkImageContainer.id = 'image-check';
  document.body.append(checkImageContainer);

  let actualPercent = 0;
  const progressBar = document.querySelector('.preloader__progressbar');
  for (let image of loaderData) {
    if (permittedExtensions.includes(getItemExtension(image.imageUrl)))
      continue;

    if (await checkImage(image.imageUrl)) {
      image.imageUrl = reduceImage(image.imageUrl, { width: 1024, quality: 75 });
      checkedSlides.push(image);
    }

    actualPercent = Math.round(checkedSlides.length / loaderData.length * 100);
    if (progressBar) progressBar.style.width = `${actualPercent}%`;
  }
  progressBar.style.width = `100%`;

  checkedSlides.sort((a, b) => {
    return a.order - b.order;
  });

  if (checkedSlides.length === 0 && !videoParams?.url) {
    skipSlider();
  } else {
    removePreloader();
    const slider = new Slider(document.body, checkedSlides, videoParams, musicParams);
    slider.launch();
  }
}

function skipSlider() {
  addTilesToScene();
  settingsData.slideShowed = true;
  removePreloader();
}

async function checkImage(url) {
  const container = document.getElementById('image-check');
  const img = document.createElement('img');
  img.height = 0;
  img.src = `${url}`;
  container.append(img);

  return new Promise((resolve) => {
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
  });
}

function getVideoParams(apiData, permittedExtensions) {
  if (apiData.length === 0)
    return;

  let currentItemExtension = getItemExtension(apiData[0].imageUrl);
  if (permittedExtensions.includes(currentItemExtension))
    return {url: apiData[0].imageUrl, position: 'start', extension: currentItemExtension};

  for (let i = 1; i < apiData.length; i++) {
    currentItemExtension = getItemExtension(apiData[i].imageUrl);
    if (permittedExtensions.includes(currentItemExtension))
      return {url: apiData[i].imageUrl, position: 'end', extension: currentItemExtension};
  }

  return {url: null, position: null, extension: null};
}

function getMusicParams() {
  const musicFileName = config.features?.sound;
  const params = {
    url: null,
    extension: null,
  };

  if (musicFileName) {
    params.url = `./audio/${musicFileName}`;
    params.extension = getItemExtension(musicFileName);
  }

  return params;
}

function getItemExtension(item) {
  const splitedUrl = item.split('.');

  return splitedUrl[splitedUrl.length - 1];
}

